import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import xmlDomUtils from '../../../../qti/utils/XmlDomUtils';
import PlainImage from './PlainImage';
import SvgImage from './SvgImage';
import { contrastOptions } from '../../../../constants/UIConstants';
import storeManager from '../../../../store/StoreManager';
import svgImageAdapterService from '../../../../services/SvgImageAdapterService';
import PlaceholderDisplay from '../placeholder/PlaceholderDisplay';

const ImageDisplay = (props) => {
    const { model } = props;
    const { ui: { contrastOption = contrastOptions.NORMAL } } = storeManager.getState();
    const [svgImage, setSvgImage] = useState(null);
    const contrastCompatible = model.originalClassNames?.includes('contrast-compatible');
    const basicContrast = [contrastOptions.NORMAL, contrastOptions.INVERTED].includes(contrastOption);
    const [usePlainImage, setUsePlainImage] = useState(basicContrast || !contrastCompatible);

    const fetchSvgImage = () => {
        const fetchInit = { mode: 'cors', credentials: 'same-origin', cache: 'reload' };

        fetch(model.url, fetchInit)
            .then(response => response.text())
            .then((xmlResponse) => {
                const svgXml = xmlDomUtils.getXmlDocFromString(xmlResponse);
                if (!svgXml) {
                    throw new Error('Response doesn\'t contain XML');
                }

                svgImageAdapterService.setTheme(svgXml.getElementsByTagName('svg')[0], contrastOption);
                const serializedSvgElement = xmlDomUtils.stringify(svgXml);
                const base64EncodedString = btoa(encodeURIComponent(serializedSvgElement).replace(/%([0-9A-F]{2})/g, (match, p1) => {
                    return String.fromCharCode(`0x${p1}`);
                }));
                setSvgImage(`data:image/svg+xml;base64,${base64EncodedString}`);
            })
            .catch((error) => {
                console.error('Failed extracting SVG', model.url, error);
                setUsePlainImage(true);
            });
    };

    useEffect(() => {
        if (!usePlainImage) {
            fetchSvgImage();
        }
    }, []);

    if (svgImage) {
        return <SvgImage content={svgImage} originSrc={model.url} {...props} />;
    } else if (!usePlainImage) {
        return <PlaceholderDisplay model={model} />;
    }

    return <PlainImage {...props} />;
};

ImageDisplay.propTypes = {
    autoScale: PropTypes.bool,
    isPreRender: PropTypes.bool,
    model: PropTypes.object.isRequired,
    maxWidth: PropTypes.number,
    reportReady: PropTypes.func,
    useModelWidthAndHeight: PropTypes.bool,
    questionObjectType: PropTypes.string,
    usePaperBasedImageDimensions: PropTypes.bool,
    useMCDiscreteWithOneImageMaxWidth: PropTypes.bool,
};

export default ImageDisplay;
